import "./DossierStepNavigation.css";

const STEP_LABELS = {
  aanmelding: "Aanmelding",
  vdab: "VDAB",
  begeleiding: "Begeleiding",
  kld: "KLD",
  afronding: "Afronding",
};

export default function DossierStepNavigation({
  steps = [],
  activeStep,
  currentStep,
  onSelectStep,
  canChangeStep = false,
  onChangeCurrentStep,
  isUpdating = false,
}) {
  return (
    <div className="dossier-step-nav">
      <div className="dossier-step-nav__header">
        <div>
          <h3>Workflow</h3>
          <p>Huidige stap: {STEP_LABELS[currentStep] || currentStep || "-"}</p>
        </div>
      </div>

      <div className="dossier-step-nav__list">
        {steps.map((step, index) => {
          const isActive = activeStep === step;
          const isCurrent = currentStep === step;

          return (
            <button
              key={step}
              type="button"
              className={`dossier-step-nav__item ${
                isActive ? "dossier-step-nav__item--active" : ""
              } ${isCurrent ? "dossier-step-nav__item--current" : ""}`}
              onClick={() => onSelectStep(step)}
            >
              <span className="dossier-step-nav__number">{index + 1}</span>

              <span className="dossier-step-nav__label">
                {STEP_LABELS[step] || step}
              </span>

              {isCurrent && <small>Huidig</small>}
            </button>
          );
        })}
      </div>

      {canChangeStep && activeStep !== currentStep && (
        <button
          type="button"
          className="dossier-step-nav__change-button"
          disabled={isUpdating}
          onClick={() => onChangeCurrentStep(activeStep)}
        >
          {isUpdating ? "Wijzigen..." : "Maak dit de huidige stap"}
        </button>
      )}
    </div>
  );
}
